import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { EmptyStatePlaceholder, EmptyStatePlaceholderVariant, StyledFlex } from '@dreryk/react-components';

import { GoBackToAuthorizerChoiceLink } from './shared/GoBackToAuthorizerChoiceLink';
import { prescriptionsHistoryDownloadTranslationKeys } from './translations';

const StyledGoBackToAuthorizerChoiceLink = styled(GoBackToAuthorizerChoiceLink)`
   display: block;
   margin-top: 8px;
`;
StyledGoBackToAuthorizerChoiceLink.displayName = 'StyledGoBackToAuthorizerChoiceLink';

type PatientWithoutIkpPlaceholderProps = {
   readonly onGoBackToAuthorizerChoiceClick: VoidFunction;
};

export const PatientWithoutIkpPlaceholder = (props: PatientWithoutIkpPlaceholderProps): JSX.Element => {
   return (
      <EmptyStatePlaceholder
         testId={'patientWithoutIkp'}
         heading={prescriptionsHistoryDownloadTranslationKeys.noConfiguredIkp}
         variant={EmptyStatePlaceholderVariant.NEGATIVE}
         subheading={
            <StyledFlex direction={'column'} gap={'8px'}>
               <Trans
                  i18nKey={prescriptionsHistoryDownloadTranslationKeys.weCantVerifyPrescriptionDownloadEntitlement}
                  components={{
                     goBackToAuthorizerChoiceLink: (
                        <StyledGoBackToAuthorizerChoiceLink onClick={props.onGoBackToAuthorizerChoiceClick} />
                     ),
                  }}
               />
            </StyledFlex>
         }
      />
   );
};
